import { AxiosPromise } from 'axios';

import apiRequest from '@/utils/apiRequest';

import { RequestUserData } from '../apiRequest/types';

type PostDeviceReturn = {
	id: string;
	is_new: boolean;
	platform: string;
	version: string;
};

export function postDevice({
	userData,
	excludedHeaders,
}: {
	userData: RequestUserData;
	excludedHeaders?: string[];
}): AxiosPromise<PostDeviceReturn> {
	return apiRequest<PostDeviceReturn>({
		endpoint: 'device',
		method: 'POST',
		userData,
		customHeaders: {
			'x-device-capabilities': 'v1;signedCookie;streamOnly',
		},
		excludedHeaders,
	});
}
